import { render, staticRenderFns } from "./TabelaResultadosServidoresUsuario.vue?vue&type=template&id=d3f4ea0a&scoped=true&"
import script from "./TabelaResultadosServidoresUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosServidoresUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosServidoresUsuario.vue?vue&type=style&index=0&id=d3f4ea0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f4ea0a",
  null
  
)

export default component.exports